<template>
  <div v-show="isLoaded" id="mobile-retailer" class="mMobile-retailer-section" v-observe-visibility="startAnimate">
    <div class="mSection-title">
      <h3>Dónde Comprar</h3>
    </div>
    <div class="mFlex-container">
      <div class="mRow">
        <a href="https://super.walmart.com.mx/cervezas/cerveza-oscura-indio-12-botellas-de-355-ml-c-u/00750106162201" @click="retailerClick('Walmart')"
          target="_blank" :class="{animate: animate}"
        >
          <img :src="Walmart" alt="Walmart" />
        </a>
        <a href="https://www.mercadolibre.com.mx/cerveza-indio-12-latas-de-355ml/p/MLM18960096?pdp_filters=category:MLM185385#searchVariation=MLM18960096&position=5&search_layout=stack&type=product&tracking_id=f36d3fdc-802b-459c-8279-c2db2e30615d" @click="retailerClick('Mercadolibre')"
          target="_blank" :class="{animate: animate}"
        >
          <img :src="MercadoLibre" alt="Mercadolibre" />
        </a>
      </div>
      <div class="mRow">
        <!-- <a href="https://www.amazon.com.mx/stores/page/822283EB-B24F-4F40-A0D7-F35D9C2CD896?ingress=0&visitId=9cc945ec-db77-4a01-a9e1-7d82ab297f0f&ref_=ast_bln" @click="retailerClick('Amazon')"
          target="_blank" :class="{animate: animate}"
        >
          <img :src="Amazon" alt="Amazon" />
        </a> -->
        <a href="https://www.chedraui.com.mx/Departamentos/Vinos-y-Licores/Cervezas/Cerveza-Oscura-Indio-12-Pack-Botella-355-ml/p/000000000003062872?siteName=Sitio+de+Chedraui" @click="retailerClick('Chedraui')"
          target="_blank" :class="{animate: animate}"
        >
          <img :src="Chedraui" alt="Chedraui" />
        </a>
        <a href="https://www.heb.com.mx/indio-cerveza-oscura-12-pack-lata-355-ml-566302/p" @click="retailerClick('Heb')"
          target="_blank" :class="{animate: animate}"
        >
          <img :src="Heb" alt="Heb" />
        </a>
      </div>
      <div class="mRow">
        <a href="https://www.ubereats.com/collection-page?collectionName=mx-indio-may" @click="retailerClick('Uber Eats')"
          target="_blank" :class="{animate: animate}"
        >
          <img :src="Uber" alt="Uber Eats" />
        </a>      
      </div>
      <!-- <div class="mRow">
        <a href="https://www.rappi.com.mx/" @click="retailerClick('Rappi')"
          target="_blank" :class="{animate: animate}"
        >
          <img :src="Rappi" alt="Rappi" />
        </a>
        <a href="https://glup.com/" @click="retailerClick('Glup')"
          target="_blank" :class="{animate: animate}"
        >
          <img :src="Glup" alt="Glup" />
        </a>
      </div> -->
    </div>
  </div>
</template>

<script>
import Amazon from "@/assets/AmazonNew.png";
import Cornershop from "@/assets/CornershopNew.png";
import Heb from "@/assets/HEB ONLINE.png";
import MercadoLibre from "@/assets/Mercado_LibreNew.png";
import Rappi from "@/assets/Rappi.png";
import SixToGo from "@/assets/SixtoGo.png";
import Walmart from "@/assets/WM ONLINE.png";
import Seveneleven from "@/assets/SEVENELEVEN.png";
import Soriana from "@/assets/SORIANA.png";
import Chedraui from '@/assets/CHEDRAUI.png';
import Glup from '@/assets/Glup.png';
import Uber from '@/assets/UberEats1.png';
import tagFunctions from '@/utils/tagFunctions.js'
import { mapGetters } from "vuex";

export default {
  name: "MobileEncuentranos",
  components: {},
  data() {
    return {
      Amazon,
      Cornershop,
      Heb,
      MercadoLibre,
      Rappi,
      SixToGo,
      Walmart,
      Seveneleven,
      Soriana,
      Chedraui,
      Glup,
      Uber,
      animate: false
    };
  },
      computed: {
    ...mapGetters(["isLoaded"]),
  },
  mounted() {
    
  },
  methods:{
    retailerClick(storeName){
      tagFunctions.evib2cOutboundlinkPush(storeName)
    },
    startAnimate(isVisible){
      if(isVisible){
        this.animate=true
      }
      
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/mobileretailerm.scss";
</style>